var i18n = {
  'en-US': {
    'routes.basic-style': 'Basic style',
    'routes.basic-style.color': 'Color',
    'routes.basic-style.font': 'Font',
    'routes.basic-style.border': 'Border',
    'routes.basic-style.shadow': 'Shadow',
    'routes.basic-style.size': 'Size',
    'routes.basic-style.icon': 'Icon',
    'routes.basic-style.hover-icon': 'Hover icon',
    'routes.components': 'Components',
    'routes.general': 'General',
    'routes.overview': 'Overview',
    'routes.icon': 'Icon',
    'routes.button': 'Button',
    'routes.link': 'Link',
    'routes.typography': 'Typography',
    'routes._layout': 'Layout',
    'routes.grid': 'Grid',
    'routes.divider': 'Divider',
    'routes.layout': 'Layout',
    'routes.space': 'Space',
    'routes.data-show': 'Data Display',
    'routes.avatar': 'Avatar',
    'routes.badge': 'Badge',
    'routes.calendar': 'Calendar',
    'routes.card': 'Card',
    'routes.collapse': 'Collapse',
    'routes.comment': 'Comment',
    'routes.descriptions': 'Descriptions',
    'routes.empty': 'Empty',
    'routes.list': 'List',
    'routes.statistic': 'Statistic',
    'routes.tabs': 'Tabs',
    'routes.table': 'Table',
    'routes.tag': 'Tag',
    'routes.timeline': 'Timeline',
    'routes.tooltip': 'Tooltip',
    'routes.popover': 'Popover',
    'routes.carousel': 'Carousel',
    'routes.tree': 'Tree',
    'routes.image': 'Image',
    'routes.data-input': 'Data Entry',
    'routes.date-picker': 'DatePicker',
    'routes.time-picker': 'TimePicker',
    'routes.input': 'Input',
    'routes.input-tag': 'InputTag',
    'routes.input-number': 'InputNumber',
    'routes.auto-complete': 'AutoComplete',
    'routes.checkbox': 'Checkbox',
    'routes.radio': 'Radio',
    'routes.rate': 'Rate',
    'routes.switch': 'Switch',
    'routes.select': 'Select',
    'routes.tree-select': 'TreeSelect',
    'routes.cascader': 'Cascader',
    'routes.slider': 'Slider',
    'routes.form': 'Form',
    'routes.upload': 'Upload',
    'routes.transfer': 'Transfer',
    'routes.mentions': 'Mentions',
    'routes.feedback': 'Feedback',
    'routes.alert': 'Alert',
    'routes.drawer': 'Drawer',
    'routes.message': 'Message',
    'routes.notification': 'Notification',
    'routes.popconfirm': 'Popconfirm',
    'routes.progress': 'Progress',
    'routes.result': 'Result',
    'routes.spin': 'Spin',
    'routes.modal': 'Modal',
    'routes.skeleton': 'Skeleton',
    'routes.nav': 'Navigation',
    'routes.breadcrumb': 'Breadcrumb',
    'routes.dropdown': 'Dropdown',
    'routes.menu': 'Menu',
    'routes.page-header': 'PageHeader',
    'routes.pagination': 'Pagination',
    'routes.steps': 'Steps',
    'routes.other': 'Others',
    'routes.config-provider': 'ConfigProvider',
    'routes.affix': 'Affix',
    'routes.anchor': 'Anchor',
    'routes.back-top': 'BackTop',
    'routes.trigger': 'Trigger',
    'routes.resize-box': 'ResizeBox',
    'routes.sketelon': 'Skeleton'
  },
  'zh-CN': {
    'routes.basic-style': '基础样式',
    'routes.basic-style.color': '颜色 Color',
    'routes.basic-style.font': '字体 Font',
    'routes.basic-style.border': '边框 Border',
    'routes.basic-style.shadow': '阴影 Shadow',
    'routes.basic-style.size': '尺寸 Size',
    'routes.basic-style.icon': '图标 Icon',
    'routes.basic-style.hover-icon': '悬浮图标',
    'routes.components': '组件',
    'routes.general': '通用',
    'routes.overview': '组件索引 Overview',
    'routes.icon': '图标 Icon',
    'routes.button': '按钮 Button',
    'routes.link': '链接 Link',
    'routes.typography': '排版 Typography',
    'routes._layout': '布局',
    'routes.grid': '栅格 Grid',
    'routes.divider': '分割线 Divider',
    'routes.layout': '布局 Layout',
    'routes.space': '间距 Space',
    'routes.data-show': '数据展示',
    'routes.avatar': '头像 Avatar',
    'routes.badge': '徽标 Badge',
    'routes.calendar': '日历 Calendar',
    'routes.card': '卡片 Card',
    'routes.collapse': '折叠面板 Collapse',
    'routes.comment': '评论 Comment',
    'routes.descriptions': '描述列表 Descriptions',
    'routes.empty': '空状态 Empty',
    'routes.list': '列表 List',
    'routes.statistic': '数值显示 Statistic',
    'routes.tabs': '标签页 Tabs',
    'routes.table': '表格 Table',
    'routes.tag': '标签 Tag',
    'routes.timeline': '时间轴 Timeline',
    'routes.tooltip': '文字气泡 Tooltip',
    'routes.popover': '气泡卡片 Popover',
    'routes.carousel': '图片轮播 Carousel',
    'routes.tree': '树 Tree',
    'routes.image': '图片 Image',
    'routes.data-input': '数据输入',
    'routes.date-picker': '日期选择器 DatePicker',
    'routes.time-picker': '时间选择器 TimePicker',
    'routes.input': '输入框 Input',
    'routes.input-tag': '标签输入框 InputTag',
    'routes.input-number': '数字输入框 InputNumber',
    'routes.auto-complete': '自动补全 AutoComplete',
    'routes.checkbox': '复选框 Checkbox',
    'routes.radio': '单选框 Radio',
    'routes.rate': '评分 Rate',
    'routes.switch': '开关 Switch',
    'routes.select': '选择器 Select',
    'routes.tree-select': '树选择 TreeSelect',
    'routes.cascader': '级联选择 Cascader',
    'routes.slider': '滑动输入条 Slider',
    'routes.form': '表单 Form',
    'routes.upload': '上传 Upload',
    'routes.transfer': '数据穿梭框 Transfer',
    'routes.mentions': '提及 Mentions',
    'routes.feedback': '反馈',
    'routes.alert': '警告提示 Alert',
    'routes.drawer': '抽屉 Drawer',
    'routes.message': '全局提示 Message',
    'routes.notification': '通知提醒框 Notification',
    'routes.popconfirm': '气泡确认框 Popconfirm',
    'routes.progress': '进度条 Progress',
    'routes.result': '结果页 Result',
    'routes.spin': '加载中 Spin',
    'routes.modal': '对话框 Modal',
    'routes.skeleton': '骨架屏 Skeleton',
    'routes.nav': '导航',
    'routes.breadcrumb': '面包屑 Breadcrumb',
    'routes.dropdown': '下拉菜单 Dropdown',
    'routes.menu': '菜单 Menu',
    'routes.page-header': '页头 PageHeader',
    'routes.pagination': '分页 Pagination',
    'routes.steps': '步骤条 Steps',
    'routes.other': '其他',
    'routes.config-provider': '全局配置 ConfigProvider',
    'routes.affix': '固钉 Affix',
    'routes.anchor': '锚点 Anchor',
    'routes.back-top': '返回顶部 BackTop',
    'routes.trigger': '触发器 Trigger',
    'routes.resize-box': '伸缩框 ResizeBox',
    'routes.sketelon': '骨架屏 Skeleton'
  }
};
export default i18n;